import { GameState, createInitialGameState } from '@/lib/chess-engine';

/**
 * Normalizes a game state from the database by ensuring proper data types
 * This is needed because JSON serialization converts Maps to plain objects
 * If gameState is null/undefined/empty, returns initial game state
 */
export const normalizeGameState = (gameState: any): GameState => {
  // If no game state provided or it's empty, return initial state
  if (!gameState || !gameState.board || !Array.isArray(gameState.board)) {
    console.log('⚠️ Invalid game state, using initial state');
    return createInitialGameState();
  }
  
  return {
    ...gameState,
    positionHistory: gameState.positionHistory instanceof Map 
      ? gameState.positionHistory
      : new Map(Object.entries(gameState.positionHistory || {}))
  };
};

/**
 * Calculate currency rewards based on game outcome
 * Win: +20 coins, +1 gem
 * Loss: -10 coins, no gems
 * Draw: +5 coins, no gems (small participation reward)
 */
export const calculateGameRewards = (
  isWinner: boolean,
  gameType: 'multiplayer' | 'bot' | 'puzzle' = 'multiplayer',
  isDraw: boolean = false
) => {
  // Handle draws first
  if (isDraw) {
    return { coins: 5, gems: 0 };
  }
  
  // Handle wins and losses
  if (isWinner) {
    return { coins: 20, gems: 1 };
  } else {
    return { coins: -10, gems: 0 }; // Loss penalty
  }
};